import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Building2, Save } from "lucide-react";
import { toast } from "sonner";

/**
 * Datos de la empresa que aparecen en cabecera del PDF (Cotización/Comprobante).
 * Solo directores pueden editar.
 */
export default function EmpresaSettings() {
  const [form, setForm] = useState({ nombre: "", nit: "", ciudad: "", telefono: "", email: "", direccion: "" });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/pedidos/_/empresa").then(({ data }) => {
      setForm({
        nombre: data.nombre || "",
        nit: data.nit || "",
        ciudad: data.ciudad || "",
        telefono: data.telefono || "",
        email: data.email || "",
        direccion: data.direccion || "",
      });
    }).finally(() => setLoading(false));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put("/pedidos/_/empresa", form);
      toast.success("Datos de la empresa guardados. Aparecerán en el PDF de los pedidos.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "No se pudo guardar");
    } finally { setSaving(false); }
  };

  if (loading) return null;

  return (
    <form onSubmit={save} className="bg-card border border-border rounded-3xl p-6 mb-8" data-testid="empresa-settings">
      <div className="flex items-center gap-2 mb-1">
        <Building2 className="w-4 h-4 text-primary" />
        <h3 className="font-display text-lg font-semibold text-foreground">Datos de la empresa</h3>
      </div>
      <p className="text-xs text-muted-foreground mb-5">
        Aparecen en la cabecera del PDF del pedido que se envía al cliente.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label className="text-xs">Nombre / Razón social</Label>
          <Input value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} className="h-11 mt-1" placeholder="Beem Importaciones SAS" data-testid="empresa-nombre" />
        </div>
        <div>
          <Label className="text-xs">NIT</Label>
          <Input value={form.nit} onChange={(e) => setForm({ ...form, nit: e.target.value })} className="h-11 mt-1" placeholder="900.xxx.xxx-x" data-testid="empresa-nit" />
        </div>
        <div>
          <Label className="text-xs">Ciudad</Label>
          <Input value={form.ciudad} onChange={(e) => setForm({ ...form, ciudad: e.target.value })} className="h-11 mt-1" placeholder="Medellín" data-testid="empresa-ciudad" />
        </div>
        <div>
          <Label className="text-xs">Teléfono</Label>
          <Input value={form.telefono} onChange={(e) => setForm({ ...form, telefono: e.target.value })} className="h-11 mt-1" placeholder="+57 300 000 0000" data-testid="empresa-telefono" />
        </div>
        <div>
          <Label className="text-xs">Correo</Label>
          <Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="h-11 mt-1" placeholder="hola@beem.moda" data-testid="empresa-email" />
        </div>
        <div>
          <Label className="text-xs">Dirección</Label>
          <Input value={form.direccion} onChange={(e) => setForm({ ...form, direccion: e.target.value })} className="h-11 mt-1" placeholder="Cll ..." data-testid="empresa-direccion" />
        </div>
      </div>
      <div className="flex justify-end mt-5">
        <Button type="submit" disabled={saving} data-testid="empresa-save">
          <Save className="w-4 h-4 mr-2" /> {saving ? "Guardando..." : "Guardar"}
        </Button>
      </div>
    </form>
  );
}
